import React from 'react';
import { SectionWrapper, CTAButton } from './Shared';
import { XCircle, CheckCircle } from 'lucide-react';
export const Closing = () => {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <SectionWrapper className="bg-prime-dark border-t border-white/5 pb-32" data-id="element-17">
      <div className="text-center mb-16" data-id="element-18">
        <h2 className="font-serif text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-19">
          Tienes dos caminos frente a ti hoy.
        </h2>
      </div>

      <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto mb-16" data-id="element-20">
        {/* Path A */}
        <div className="bg-prime-black border border-white/10 rounded-xl p-8 opacity-70 grayscale hover:grayscale-0 transition-all duration-500" data-id="element-21">
          <div className="flex items-center gap-3 mb-6 border-b border-white/10 pb-4" data-id="element-22">
            <XCircle className="w-8 h-8 text-prime-redBright" data-id="element-23" />
            <h3 className="text-2xl font-bold text-white" data-id="element-24">Camino A</h3>
          </div>
          <p className="text-prime-textMuted text-lg leading-relaxed" data-id="element-25">
            No haces nada. Sigues sintiéndote fatigado, viendo cómo la barriga
            crece año tras año y aceptando que "esto es lo que hay".
          </p>
        </div>

        {/* Path B */}
        <div className="bg-gradient-to-br from-prime-card to-prime-black border-2 border-prime-gold rounded-xl p-8 shadow-[0_0_30px_rgba(212,168,83,0.1)] transform md:-translate-y-4" data-id="element-26">
          <div className="flex items-center gap-3 mb-6 border-b border-prime-gold/20 pb-4" data-id="element-27">
            <CheckCircle className="w-8 h-8 text-prime-gold" data-id="element-28" />
            <h3 className="text-2xl font-bold text-prime-gold" data-id="element-29">Camino B</h3>
          </div>
          <p className="text-white text-lg leading-relaxed font-medium" data-id="element-30">
            Tomas el mando. Inviertes menos de lo que cuesta un tanque de
            gasolina en el sistema que reconstruirá tu presencia, tu energía y
            tu físico.
          </p>
        </div>
      </div>

      <div className="text-center" data-id="element-31">
        <p className="font-serif text-3xl text-white italic mb-10" data-id="element-32">
          La elección es tuya, Arquitecto.
        </p>
        <CTAButton onClick={scrollToPricing} data-id="element-33">
          SÍ, QUIERO RECLAMAR MI VIGOR — ACCESO INMEDIATO POR $6,39
        </CTAButton>
      </div>
    </SectionWrapper>;
};